import { Component, Input, TemplateRef, SimpleChanges  } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { TransformKeyPipe } from '../../../../pipes/transform-key.pipe';
import { getValueByPath } from '../../../../utils/get-value-by-path';
import { TimezonePipe } from '../../../../pipes/timezone.pipe';

@Component({
  selector: 'app-update-view',
  standalone: true,
  templateUrl: './update-view.html',
  styleUrls: ['./update-view.scss'],
  imports: [CommonModule, TransformKeyPipe, TimezonePipe],
})
export class UpdateView {
  comparisonField: string = '';
  comparisonOld: any = null;
  comparisonNew: any = null;

  openComparisonPopup(field: string, oldValue: any, newValue: any, template: TemplateRef<any>) {
    this.comparisonField = field;
    this.comparisonOld = oldValue;
    this.comparisonNew = newValue;
    console.log('Opening comparison popup with:', field);
    this.modalService.open(template, { size: 'xl', backdrop: 'static' });
  }

  getComparisonFields(oldObj: any, newObj: any): string[] {
    const oldKeys = oldObj ? Object.keys(oldObj) : [];
    const newKeys = newObj ? Object.keys(newObj) : [];
    return Array.from(new Set([...oldKeys, ...newKeys]));
  }

  getComparisonValue(obj: any, key: string): any {
    if (obj && obj[key] !== undefined) {
      return obj[key];
    }
    return 'N/A';
  }
  
  @Input() logData: any;
  @Input() props: any;
  viewLogsData: any;

  // Stack of popups
  popupStack: Array<{ title: string; data: any }> = [];

  getValueByPath = getValueByPath;
  ngOnInit() {
    // console.log(this.logData);
    // Initialization logic here
    this.viewLogsData = this.logData;
    // this.searchText = this.boo
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes['logData']) {
  //     // console.log('logData changed:', changes['logData'].currentValue);
  //     // do something when logData updates
  //   }
  //   if (changes['props']) {
  //     // console.log('props changed:', changes['props'].currentValue);
  //     // do something when props updates
  //   }
  // }

  constructor(private modalService: NgbModal) {}

  // Wrapper method for template to open popup
openPopupFromKey(title: unknown, data: any, template: TemplateRef<any>) {
  const safeTitle = String(title); // Convert unknown to string
  this.openPopup(safeTitle, data, template);
}
  // Push data to stack and open modal
  openPopup(title: string, data: any, content: TemplateRef<any>) {
    this.popupStack.push({ title, data });
    this.modalService.open(content, { size: 'lg', backdrop: 'static' });
  }

  // Remove topmost popup from stack when modal is closed
  closePopup() {
    this.popupStack.pop();
  }

  get popupTitle(): string {
    return this.popupStack.length
      ? this.popupStack[this.popupStack.length - 1].title
      : '';
  }

  get popupData(): any {
    return this.popupStack.length
      ? this.popupStack[this.popupStack.length - 1].data
      : null;
  }

  isObject(value: unknown): value is Record<string, any> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }

  isArray(value: unknown): value is any[] {
    return Array.isArray(value);
  }

  // Detect if object is "object of objects"
isObjectOfObjects(value: any): boolean {
  if (!this.isObject(value)) return false;
  const keys = Object.keys(value);
  return keys.length > 0 && this.isObject(value[keys[0]]);
}

// For array-of-objects / nested object headers
getObjectKeys(obj: any): string[] {
  if (!obj) return [];
  return Object.keys(obj);
}

// Collect all nested keys for consistent headers
getNestedObjectKeys(obj: any): string[] {
  if (!this.isObject(obj)) return [];
  const allKeys = new Set<string>();
  Object.values(obj).forEach((val: any) => {
    if (this.isObject(val)) {
      Object.keys(val).forEach(k => allKeys.add(k));
    }
  });
  return Array.from(allKeys);
}

asAny(value: unknown): any {
  return value as any;
}
}
